import React from "react";
import UserWrapper from "../users/loggedUser/shared/UserWrapper";
import { Header, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";
const NotFoundComponent = () => (
  <UserWrapper headerless>
    <Segment basic>
      <Header size="huge" style={{ color: "white", fontSize: 50 }}>
        404
        <Header.Subheader style={{ color: "white" }}>
          Are you lost?{" "}
          <Link to="/" style={{ color: "white", fontWeight: "bold" }}>
            Go back to main page
          </Link>
        </Header.Subheader>
      </Header>
    </Segment>
  </UserWrapper>
);

export default NotFoundComponent;



// WEBPACK FOOTER //
// ./src/components/NotFoundComponent.js